import { memo } from 'react';
import { useFrame, withErrorBoundary } from '~/shared/utils';
import styles from './n10-meta.module.css';
import { weakKey } from '~/shared/utils/jsx';
import { CMSLink } from '~/shared/components';
import { Usp } from '../components/usp.component';
import { Container } from '~/templates/blocks/components/container/container.component';

const N10Meta = memo(() => {
    const { data } = useFrame();
    const { metaMenu } = data?.navigation || {};
    const { uspList } = data?.usp || {};

    return (
        <div className={styles.root}>
            <Container hasGutter>
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        {uspList?.length ? <Usp uspItems={uspList} isAnimated /> : null}
                        {!!metaMenu?.length && (
                            <ul className={styles.list}>
                                {metaMenu.map((link) => (
                                    <li key={weakKey(link)}>
                                        <CMSLink className={styles.link} href={link.url}>
                                            {link.text}
                                        </CMSLink>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    );
});

export default withErrorBoundary(N10Meta);
